// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "reactPlayerPreview" + "." + "810273d7" + ".chunk.js";
};